<template>
  <div id="topbar">
    <nav class="oneline-flex">
      <a href="">
        <div class="frame"><img src="../assets/logo.jpg" alt="logo"></div>
      </a>
      <ul class="oneline-flex">
        <li><router-link to='/home'>Home</router-link></li>
        <li><router-link to='/blog'>Blog</router-link></li>
        <li><router-link to='/mywork'>My Work</router-link></li>
        <li><router-link to='/sidework'>My Side Work</router-link></li>
      </ul>
      <div class="text-right">
        <p><a href="https://github.com/yuanyayi" target="_blank"><i class="fa fa-github"></i>github</a> | <a href="https://www.jianshu.com/u/64f0eb4f9ad2" target="_blank" style="color: #ea6f5a; font-weight: bold;">简书</a></p>
        <p><i class="fa fa-mobile-phone"></i>16619897390</p>
        <p><i class="fa fa-envelope-o"></i>16619897390@163.com</p>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'Topbar'
  }
</script>

<style lang="sass">
  @import 'assets/style/variable.sass'
  #topbar
    padding: 10px
    padding-bottom: 0
    background-color: $theme
    color: #fff
    nav 
      .frame 
        width: 100px
        height: 50px
        border-radius: 50%
        border: 1px solid #e5e5e5
        img
          position: absolute
          top: 50%
          left: 50%
          transform: translate(-50%, -50%)
      ul
        font-size: 1.5em
        flex: 8
        li
          position: relative
          margin: auto 10px
          cursor: pointer
        li:hover
          a::after
            @include line-after($width: 50%, $color: $theme)
        .router-link-active::after
          @include line-after($width: 50%, $color: $theme)
    .text-right
      width: 200px
      flex: 1 0 auto
      text-align: right
    i.fa 
      margin-right: .2em
</style>


// WEBPACK FOOTER //
// src/components/Topbar.vue